import { render, staticRenderFns } from "./WorkspaceBar.vue?vue&type=template&id=e842f9d0&scoped=true&"
import script from "./WorkspaceBar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceBar.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceBar.vue?vue&type=style&index=0&id=e842f9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e842f9d0",
  null
  
)

export default component.exports